import React from "react";
import Text from "src/components/text";

import { formatTimespent } from "src/services/reports.service";

import styles from "./topViewerListItem.module.scss";
import _ from "lodash";
import { Contact } from "src/types/contact";
import { Analytics } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface TopViewerItem {
  contact: Contact;
  analytics: Analytics;
}

interface TopViewerListItemProps {
  item: TopViewerItem;
  columnCount: number;
  onClick?: () => void;
}

const TopViewerListItem: React.FC<TopViewerListItemProps> = ({
  item,
  columnCount,
  onClick
}) => {
  const { contact, analytics } = item;
  return (
    <div className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={contact.icon?.thumbnail || DefaultAssetIcon}
          className={`${styles.thumbnailIcon} ${styles.contactIcon}`}
          alt={`${contact.firstName} ${contact.lastName}`}
        />
        <div className={styles.rightData} onClick={onClick} style={{ cursor: "pointer" }}>
          <div className={styles.tableDataTitle}>
            <Text
              text={`${contact.firstName}${contact.lastName ? ` ${contact.lastName}` : ""}`}
              className={styles.title}
              lines={1}
            />
          </div>
          <span className={styles.metaData}>
            {contact.createdDate && (
              <span className={styles.name}>
                Added:{" "}
                {new Date(contact.createdDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </span>
            )}
            <div className={styles.name}>{contact.company}</div>
          </span>
        </div>
        <div className={styles.tableDataSubtitle}>{contact?.role}</div>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>{analytics.views}</div>
        <div className={styles.tableDataTime}>
          {formatTimespent(_.get(analytics, "avgTimeSpent", 0))}
        </div>
        <div className={styles.tableDataShares}>{analytics.shares}</div>
      </div>
    </div>
  );
};

export default TopViewerListItem;
